import { Alert } from "@mui/material";
import Typography from "@mui/material/Typography";
import {
  BooleanField,
  BooleanInput,
  AutocompleteArrayInput,
  DatagridConfigurable,
  Edit,
  EditButton,
  FunctionField,
  List,
  ReferenceArrayInput,
  required,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  WrapperField,
} from "react-admin";
import LocalisedDateField from "../components/localisedDateField";
import { TextArrayEmailInput } from "../components/TextArrayEmailInput";

export const FeatureFlagsList = (props: any) => {
  return (
    <List {...props} title={"Feature Flags"} sort={{ field: "updated_at", order: "DESC" }} exporter={false}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="name" />
        <TextField source="description" label="Description" />
        <BooleanField source="enabled" label="Active" />
        <FunctionField
          render={(record: any) => {
            const emailCount = record.emails?.length || 0;
            const localeCount = record.localeIds?.length || 0;
            if (!emailCount && !localeCount) return "Global";
            return `${emailCount} email${emailCount === 1 ? "" : "s"}, ${localeCount} locale${
              localeCount === 1 ? "" : "s"
            }`;
          }}
          label="Audience"
        />
        <FunctionField
          render={(record: any) => <LocalisedDateField record={record} field="createdAt" compact />}
          label="Created"
        />
        <FunctionField
          render={(record: any) => <LocalisedDateField record={record} field="updatedAt" compact />}
          label="Updated"
        />
        <WrapperField label="Actions">
          <EditButton />
        </WrapperField>
      </DatagridConfigurable>
    </List>
  );
};
const FeatureFlagsEditAside = () => {
  return (
    <div style={{ width: 200, margin: "1em" }}>
      <Typography variant="h6">Metadata</Typography>
      <p>
        Created{" "}
        <FunctionField
          render={(record: any) => <LocalisedDateField record={record} field="createdAt" showTime={true} />}
        />
      </p>
      <p>
        Updated{" "}
        <FunctionField
          render={(record: any) => <LocalisedDateField record={record} field="updatedAt" showTime={true} />}
        />
      </p>
      <p>
        Updated By: <TextField source="updatedBy" />
      </p>
    </div>
  );
};

const SaveOnlyToolbar = () => {
  return (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  );
};
export const FeatureFlagsEdit = () => {
  return (
    <Edit aside={<FeatureFlagsEditAside />} mutationMode="pessimistic">
      <Alert severity="info" sx={{ mb: 2 }}>
        If a flag is <b>disabled</b>, it's <b>disabled for everyone</b>. <br />
        If an enabled flag has <b>no emails or locales</b>, it is <b>enabled globally</b>. <br />
        Otherwise it is enabled when the user's <b>email matches</b> or their country matches <b>any selected locale</b>
        .
      </Alert>
      <SimpleForm toolbar={<SaveOnlyToolbar />}>
        <TextInput source="name" validate={required()} disabled />
        <TextInput source="description" validate={required()} fullWidth />
        <BooleanInput source="enabled" />
        <TextArrayEmailInput source="emails" />
        <ReferenceArrayInput source="localeIds" reference="locales" perPage={250}>
          <AutocompleteArrayInput
            label="Country locales"
            optionText={(record: any) => `${record.name} (${record.id}, ${record.country})`}
            filterToQuery={(query: string) => ({ name__icontains: query })}
            helperText="Selecting any locale enables the flag for that locale's entire country."
            fullWidth
          />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
};
